// extracted by mini-css-extract-plugin
var _1 = "Course_body__501a7";
var _2 = "Course_contentWrapper__753eb";
var _3 = "Course_header__edc9c";
var _4 = "Course_positionsRight__34bff";
var _5 = "Course_root__89ee1";
var _6 = "Course_tooltipPortal__dbfc5";
var _7 = "Course_trial__e659b";
export { _1 as "body", _2 as "contentWrapper", _3 as "header", _4 as "positionsRight", _5 as "root", _6 as "tooltipPortal", _7 as "trial" }
